// Geometry for Google's Map Tiles viewport-attribution request: the lat/lon
// box and zoom of the area actually on screen. Kept free of Cesium so it can
// be tested directly; googleViewportAttribution.ts feeds it camera picks.
const EARTH_CIRCUMFERENCE_M = 40075016.686;
const SAMPLES_PER_EDGE = 5;
// About 10 m; keeps sub-pixel camera settle from re-requesting the same view.
const KEY_PRECISION_DEG = 4;
// Evenly spaced points across a rect, edges included, so the box still covers
// the visible ground when the corners look past the horizon.
export const sampleRect = (rect) => {
    const points = [];
    const steps = SAMPLES_PER_EDGE - 1;
    for (let i = 0; i <= steps; i++) {
        for (let j = 0; j <= steps; j++) {
            points.push({ x: rect.x + (rect.width * i) / steps, y: rect.y + (rect.height * j) / steps });
        }
    }
    return points;
};
export const boundsOfPoints = (points) => {
    if (points.length === 0)
        return null;
    let north = -90;
    let south = 90;
    let east = -180;
    let west = 180;
    for (const p of points) {
        north = Math.max(north, p.latDeg);
        south = Math.min(south, p.latDeg);
        east = Math.max(east, p.lonDeg);
        west = Math.min(west, p.lonDeg);
    }
    return { north, south, east, west };
};
// The web-mercator level whose tiles land closest to one tile texel per
// drawing-buffer pixel at this latitude, which is the level Cesium requests.
export const zoomForResolution = (metersPerPixel, latDeg, tileWidth, minLevel, maxLevel) => {
    const groundPerTile = tileWidth * metersPerPixel;
    const raw = Math.log2((EARTH_CIRCUMFERENCE_M * Math.cos((latDeg * Math.PI) / 180)) / groundPerTile);
    return Math.min(maxLevel, Math.max(minLevel, Math.round(raw)));
};
export const viewportQueryKey = (q) => [q.zoom, q.north, q.south, q.east, q.west]
    .map((v, i) => (i === 0 ? String(v) : v.toFixed(KEY_PRECISION_DEG)))
    .join('|');
